import { render } from "./calltoaction.vue?vue&type=template&id=29877bb9"
import script from "./calltoaction.vue?vue&type=script&lang=js"
export * from "./calltoaction.vue?vue&type=script&lang=js"

import "./calltoaction.vue?vue&type=style&index=0&id=29877bb9&lang=scss"
script.render = render

export default script